import React from 'react';
import { useSearchParams } from 'react-router-dom';
import '../styles/congratulations.css';
import { useMetadata } from '../hooks/useMetadata';

const RejectionReminderPage: React.FC = () => {
  useMetadata();
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email') || '';
  
  return (
    <div className="congratulations-container">
      <div className="congratulations-header">
        <img 
          src="/logo-ole-mx.png" 
          alt="Olé Logo" 
          className="congratulations-logo"
        />
      </div>
      <div className='rejected-icon'>
        <img 
          src="/icon-sign-rejected.png" 
          alt="Olé Logo" 
          className="congratulations-logo"
        />
      </div>
      <div className="rejected-content">
        <div className="rejected-message">
          <h1 data-testid="rechazo-titulo-principal" className="rejected-title">
            Has rechazado la firma de tu solicitud
          </h1>
          <p data-testid="rechazo-texto-descripcion" className="rejected-description">
            Lamentamos comunicarte que al haber rechazo la firma electrónica, tu <br/> <b>solicitud ha sido cancelada</b> por ti.
          </p>
          <p className="rejected-description">
            Para iniciar una nueva solicitud, comunícate con nosotros a <br/><a data-testid="rechazo-link-contacto" className="rejected-link" href='mailto:atencionalcliente@ole-sp.com.mx'>atencionalcliente@ole-sp.com.mx</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default RejectionReminderPage;